import { IconSVGProps } from "./types";

const PdfIcon = ({ height = 24, width = 24, className }: IconSVGProps) => (
    <svg
        className={className}
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_1666_24)">
            <path
                opacity="0.4"
                d="M0 3C0 1.34531 1.34531 0 3 0H10.5V6C10.5 6.82969 11.1703 7.5 12 7.5H18V14.25H8.25C6.59531 14.25 5.25 15.5953 5.25 17.25V24H3C1.34531 24 0 22.6547 0 21V3Z"
                fill="#002649"
            />
            <path
                d="M18 7.5L10.5 0V6C10.5 6.82969 11.1703 7.5 12 7.5H18ZM8.25 16.5C7.8375 16.5 7.5 16.8375 7.5 17.25V21V23.25C7.5 23.6625 7.8375 24 8.25 24C8.6625 24 9 23.6625 9 23.25V21.75H9.75C11.1984 21.75 12.375 20.5734 12.375 19.125C12.375 17.6766 11.1984 16.5 9.75 16.5H8.25ZM9.75 20.25H9V18H9.75C10.3734 18 10.875 18.5016 10.875 19.125C10.875 19.7484 10.3734 20.25 9.75 20.25ZM14.25 16.5C13.8375 16.5 13.5 16.8375 13.5 17.25V23.25C13.5 23.6625 13.8375 24 14.25 24H15.75C16.9922 24 18 22.9922 18 21.75V18.75C18 17.5078 16.9922 16.5 15.75 16.5H14.25ZM15.75 22.5H15V18H15.75C16.1625 18 16.5 18.3375 16.5 18.75V21.75C16.5 22.1625 16.1625 22.5 15.75 22.5ZM19.5 17.25V20.25V23.25C19.5 23.6625 19.8375 24 20.25 24C20.6625 24 21 23.6625 21 23.25V21H22.5C22.9125 21 23.25 20.6625 23.25 20.25C23.25 19.8375 22.9125 19.5 22.5 19.5H21V18H22.5C22.9125 18 23.25 17.6625 23.25 17.25C23.25 16.8375 22.9125 16.5 22.5 16.5H20.25C19.8375 16.5 19.5 16.8375 19.5 17.25Z"
                fill="#002649"
            />
        </g>
        <defs>
            <clipPath id="clip0_1666_24">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default PdfIcon;
